import React from "react";
import styles from "./TopDecorations.module.scss";

const StarIcon: React.FC<{ className?: string; size?: number }> = ({ className, size = 20 }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2L12.5 7.5L18 10L12.5 12.5L10 18L7.5 12.5L2 10L7.5 7.5L10 2Z"
        fill="#D3D3D3"
      />
    </svg>
  );
};

export const TopDecorations: React.FC = () => {
  return (
    <div className={styles.root}>
      <StarIcon className={styles.star1} size={16} />
      <StarIcon className={styles.star2} size={14} />
      <StarIcon className={styles.star3} size={12} />
      <StarIcon className={styles.star4} size={18} />
      <StarIcon className={styles.star5} size={10} />
      <StarIcon className={styles.star6} size={15} />
      <StarIcon className={styles.star7} size={13} />
      <StarIcon className={styles.star8} size={11} />
    </div>
  );
};

